import { render, staticRenderFns } from "./DeleteApiKeyPopup.vue?vue&type=template&id=10ba8c2e"
import script from "./DeleteApiKeyPopup.vue?vue&type=script&lang=js"
export * from "./DeleteApiKeyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports